package com.xtream.ui.ui.widget

 import androidx.annotation.FloatRange
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.basicMarquee
import androidx.compose.foundation.clickable
import androidx.compose.foundation.hoverable
import androidx.compose.foundation.interaction.MutableInteractionSource
 import androidx.compose.foundation.interaction.collectIsFocusedAsState
 import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredSize
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Movie
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawWithContent
 import androidx.compose.ui.geometry.CornerRadius
 import androidx.compose.ui.geometry.Offset
 import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.Shape
 import androidx.compose.ui.graphics.drawscope.Stroke
 import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.painter.BitmapPainter
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.VectorPainter
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import coil3.compose.AsyncImagePainter
import coil3.compose.ConstraintsSizeResolver
import coil3.compose.LocalPlatformContext
import coil3.compose.asPainter
import coil3.compose.rememberConstraintsSizeResolver
 import com.xtream.ui.platform.isDpadNavigation
 import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.withContext


enum class Visibility{
    VISIBLE_ALWAYS,
    VISIBLE_ON_FOCUS,
    HIDE
}

@Composable
expect fun rememberPlatformImagePainter(
    src: String?,
    sizeResolver: ConstraintsSizeResolver
):  AsyncImagePainter // painter + isLoaded


@Composable
fun ImageCardHorizontal(
    modifier: Modifier = Modifier,
    isSelected: Boolean = false,
    imagePainter: Painter? = null,
    title: String,
    description: String? = null,
    imageShape: Shape = RoundedCornerShape(3.dp),
    imageAspectRatio: Float = 2f / 3f,
    onLongClick: () -> Unit = {},
    minHeight: Dp = 35.dp,
    maxHeight: Dp = 55.dp,
    onClick: () -> Unit = {},
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()
    // val isPressed by interactionSource.collectIsPressedAsState()

    Card(
        modifier = modifier
            .wrapContentHeight()
            .heightIn(min = minHeight, max = maxHeight)
            .hoverable(interactionSource)
            .clickable(
                interactionSource = interactionSource,
                indication = null,
                onClick = onClick
            ),
        colors = androidx.compose.material3.CardDefaults.cardColors(
            contentColor = if (isHovered) MaterialTheme.colorScheme.background
            else MaterialTheme.colorScheme.onBackground,
            containerColor = if (isHovered) MaterialTheme.colorScheme.onBackground
            else if (isSelected) MaterialTheme.colorScheme.surfaceVariant
            else MaterialTheme.colorScheme.surfaceVariant
        ),
        shape = RoundedCornerShape(3.dp),
        border = if (isHovered) BorderStroke(2.dp, MaterialTheme.colorScheme.primary) else null,
    ) {
        Row(
            modifier = Modifier.padding(8.dp).fillMaxSize(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            CardLogo(
                imagePainter = imagePainter,
                imageShape = imageShape,
                imageAspectRatio = imageAspectRatio,
            )
            Column(
                modifier = Modifier.padding(horizontal = 8.dp).weight(.8f).fillMaxSize(),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.Start,
            ) {
                Text(
                    text = title,
                    style = MaterialTheme.typography.titleMedium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
                if (description != null) {
                    Text(
                        text = description,
                        style = MaterialTheme.typography.bodySmall,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                }
            }
        }
    }
}





@Composable
private fun CardLogo(
    modifier: Modifier= Modifier,
    imagePainter: Painter? = null,
    imageSize: Dp = 24.dp,
    contentDescription: String? = null,
    imageShape: Shape = RoundedCornerShape(6.dp),
    imageAspectRatio: Float = 1f,
) {
    val isVector = imagePainter is VectorPainter

    imagePainter ?: return

    Image(
        painter = imagePainter,
        contentDescription = contentDescription,
        colorFilter = if (isVector) ColorFilter.tint(MaterialTheme.colorScheme.primary.copy(alpha = .2f)) else null,
        contentScale = if (isVector) ContentScale.Inside else ContentScale.Crop,
        modifier = modifier
            .requiredSize(imageSize)
            .clip(imageShape)
            .background(MaterialTheme.colorScheme.secondaryContainer)
            .aspectRatio(imageAspectRatio)
    )
}




@Composable
fun ImageCard(
    imagePainter: Painter,
    modifier: Modifier = Modifier,
    title: String?=null,
    description: String?=null,
    infoSectionVisibility:  Visibility =  Visibility.VISIBLE_ALWAYS,
    onClick: () -> Unit = {},
    aspectRatio: Float= 2f / 3f,
    dependOnWidth: Boolean = true,
    width: Dp = 124.dp,
    height: Dp = 124.dp, //TODO: in next app updates we should use Dp.Unspecified instead of depend on width
    textAlign: TextAlign? = null,
    @FloatRange(from= 0.0,to=1.0)
    progress: Float=0f
){

     BaseImageCard(
        modifier = modifier,
        title = title,
        description = description,
        infoSectionVisibility = infoSectionVisibility,
        onClick = onClick,
        aspectRatio = aspectRatio,
        dependOnWidth = dependOnWidth,
        width = width,
        height = height,
        focusedScale = 1f,
        textAlign = textAlign,

        progress = progress
    ) {
        //        imagePainter =  rememberAsyncImagePainter(model = src, filterQuality = FilterQuality.Medium, placeholder = rememberVectorPainter(Icons.Default.Movie), error = rememberVectorPainter(Icons.Default.Movie)) ,
        Image(
            painter = imagePainter,
            contentDescription = title,

            contentScale = ContentScale.FillWidth,
            //filterQuality = FilterQuality.Medium,
            modifier = Modifier.fillMaxSize(),
            colorFilter = ColorFilter.tint(MaterialTheme.colorScheme.onBackground)

        )
    }
}

expect val DefaultCardWidth: Dp
@Composable
fun NetworkImageCard(
    src: String?,
    modifier: Modifier = Modifier,
    title: String?=null,
    description: String?=null,
    useAutoAlpha: Boolean=false,
    showTitle: Boolean=true,
    infoSectionVisibility: Visibility =  Visibility.VISIBLE_ALWAYS,
    onClick: () -> Unit = {},
    aspectRatio: Float= 2f / 3f,
    dependOnWidth: Boolean = true,
    width: Dp = DefaultCardWidth,
    height: Dp = 124.dp, //TODO: in next app updates we should use Dp.Unspecified instead of depend on width
    focusedScale: Float=1f,
    textAlign: TextAlign? = null,
    @FloatRange(from= 0.0,to=1.0)
    progress: Float=0f,
    sizeResolver: ConstraintsSizeResolver = rememberConstraintsSizeResolver(),
    onBitmapLoaded: ((Painter) -> Unit)? = null
){


    // ✅ PLATFORM IMAGE LOADER (your abstraction)
    val painter= rememberPlatformImagePainter(src, sizeResolver)



    // Detect when the image is successfully loaded
    val state by painter.state.collectAsStateWithLifecycle()

    /*LaunchedEffect(sizeResolver) {
        Log.d("ImageCard", "sizeResolver changed: ${sizeResolver.size()}")
    }*/
    // 1. Create a single transparent bitmap instance once
    /* val transparentPlaceholder = remember {
         createBitmap(1, 1).apply {
             eraseColor(android.graphics.Color.TRANSPARENT)
         }
     }*/


    BaseImageCard(
        modifier = modifier,
        title = title,
        description = description,
        useAutoAlpha = useAutoAlpha,
        infoSectionVisibility = infoSectionVisibility,
        onClick = onClick,
        aspectRatio = aspectRatio,
        showTitle = showTitle,
        focusedScale = focusedScale,
        dependOnWidth = dependOnWidth,
        textAlign = textAlign,
        width = width,
        height = height,
        progress = progress
    ) { focused ->

        Image(
            modifier = Modifier
                .fillMaxSize()
                .then(sizeResolver),
            painter = when (state) {
                is AsyncImagePainter.State.Success -> painter
                else -> {
                    rememberVectorPainter(Icons.Default.Movie)
                }
            },
            contentDescription = title,
            contentScale = ContentScale.Crop,


            )

        val transparentPlaceholderPainter: Painter = remember {
            // 1. Create a tiny 1x1 empty transparent bitmap
            val bitmap = ImageBitmap(width = 1, height = 1)

            // 2. Wrap it inside a BitmapPainter to make it a usable Painter object
            BitmapPainter(bitmap)
        }
        val platformContext = LocalPlatformContext.current
// 2. Use LaunchedEffect to react only to relevant changes
        LaunchedEffect(state, focused) {
            if (focused) {
                // 1. Wait for the user to stay focused for a bit (e.g., 170ms)
                // If 'focused' or 'state' changes during this delay,
                // this coroutine is cancelled and restarted automatically.
                delay(170L)
                when (val currentState = state) {
                    is AsyncImagePainter.State.Success -> {
                        // Perform the conversion in the CoroutineScope of LaunchedEffect
                        val bitmap = withContext(Dispatchers.Default) {
                            currentState.result.image.asPainter(platformContext)
                        }
                        onBitmapLoaded?.invoke(bitmap)
                    }

                    else -> {
                        onBitmapLoaded?.invoke(transparentPlaceholderPainter )
                    }
                }
            }
        }
    }


}



@Composable
  fun BaseImageCard(
    modifier: Modifier = Modifier,
    title: String? = null,
    description: String? = null,
    infoSectionVisibility:  Visibility =  Visibility.VISIBLE_ALWAYS,
    onClick: () -> Unit = {},
    useAutoAlpha: Boolean = false,
    showTitle: Boolean = true,
    aspectRatio: Float = 2f / 3f,
    dependOnWidth: Boolean = true,
    width: Dp = 124.dp,
    height: Dp = 124.dp,

    textAlign: TextAlign? = null,
    focusedScale: Float = 1.1f,
    @FloatRange(from = 0.0, to = 1.0) progress: Float = 0f,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    focusedBorderColor: Color = MaterialTheme.colorScheme.onBackground,
    content: @Composable (BoxScope.(focused: Boolean) -> Unit)
){
    val focusState by interactionSource.collectIsFocusedAsState()
    val isDpadNavigation = isDpadNavigation()

    Card (
        modifier = modifier
            .wrapContentHeight()
            .graphicsLayer {
                //   scaleX = if (focusState) focusedScale else 1f
                // scaleY = if (focusState) focusedScale else 1f
            }
            .clickable(
                interactionSource = interactionSource,
                indication = null,
                onClick = onClick
            ),
        shape = RoundedCornerShape(5.dp),
        colors = CardDefaults.cardColors(
            containerColor = if (infoSectionVisibility ==  Visibility.VISIBLE_ON_FOCUS)
                Color.Transparent else MaterialTheme.colorScheme.surfaceVariant
        )
    ) {

        // IMAGE BOX
        Box(
            modifier = Modifier
                .drawWithContent {
                    drawContent()
                   if (focusState) {
                         val strokeWidth = 2.dp.toPx()
                         drawRoundRect(
                             color = focusedBorderColor,
                             topLeft = Offset(strokeWidth / 2, strokeWidth / 2),
                             size = size.copy(
                                 width = size.width - strokeWidth,
                                 height = size.height - strokeWidth
                             ),
                             style = Stroke(width = strokeWidth),
                             cornerRadius = CornerRadius(5.dp.toPx())
                         )
                     }
                }
                .clip(RoundedCornerShape(5.dp))
                .then(
                    if (dependOnWidth) {
                        if (width <= 0.dp) Modifier.fillMaxWidth()
                        else Modifier.width(width)
                    } else {
                        Modifier.height(height)
                    }
                )
                .aspectRatio(aspectRatio)
                .background(MaterialTheme.colorScheme.secondaryContainer)
                .graphicsLayer {
                    alpha =
                        if (isDpadNavigation && useAutoAlpha) (if (focusState) 1f else 0.7f) else 1f
                }

        ) {

            content(this, false)

            if (progress > 0f) {
                LinearProgressIndicator(
                    progress = { progress.coerceIn(0f, 1f) },
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(4.dp)
                        .align(Alignment.BottomCenter),
                    color = MaterialTheme.colorScheme.primary,
                    trackColor = MaterialTheme.colorScheme.background.copy(alpha = 0.7f),
                )
            }
        }

        // INFO SECTION
         CardInfoLayout(
            showTitle = showTitle,
            isFocused = false,
            infoSectionVisibility = infoSectionVisibility,
            cardWidthDp = if (width > 0.dp && dependOnWidth) width else Dp.Unspecified,
            title = title,
            description = description,
            textAlign = textAlign
        )
    }
  }


@Composable
fun CardInfoLayout(
    showTitle: Boolean,
    isFocused: Boolean,
    title: String?,
    description: String?,
    textAlign: TextAlign?,
    infoSectionVisibility: Visibility,
    cardWidthDp: Dp,


    ){
    if (showTitle&& infoSectionVisibility!= Visibility.HIDE) {
        val movieNameAlpha: Float by animateFloatAsState(
            targetValue =
                when( infoSectionVisibility) {
                    Visibility.VISIBLE_ALWAYS -> 1f
                    Visibility.VISIBLE_ON_FOCUS -> if (isFocused) 1f else 0f
                    Visibility.HIDE -> 0f
                }


            ,
            label = "",
        )


        Column(
            modifier = Modifier
                .width(cardWidthDp)
                .heightIn(max = 30.dp)
                .graphicsLayer {
                    alpha = movieNameAlpha
                }
                .padding(top = 8.dp)
            ,

            ) {
            Title( title = title ?: "", textAlign = textAlign, isFocused =isFocused )
            if(description!=null)
                Description(description = description, textAlign = textAlign)
        }


    }
}

@Composable
private fun Title(title: String, modifier: Modifier = Modifier,
                  textAlign: TextAlign? = TextAlign.Start, isFocused: Boolean =false ){
    Text(
        modifier = modifier
            .height(25.dp)
            .fillMaxWidth()
            .padding(horizontal = 4.dp)
            .then(
                if (isFocused) Modifier.basicMarquee() else Modifier
            ),
        textAlign = textAlign,
        text = title?:"",
        style = MaterialTheme.typography.bodyMedium,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        color = MaterialTheme.colorScheme.onBackground//.copy(alpha = .6f)
    )
}

@Composable
private fun Description(description: String, textAlign: TextAlign? = TextAlign.Start, modifier: Modifier = Modifier) {
    Text(
        modifier = modifier
            .heightIn(min = 12.dp)
            .padding(horizontal = 4.dp),
        textAlign = textAlign,

        text = description,
        style = MaterialTheme.typography.bodySmall,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        color = MaterialTheme.colorScheme.onBackground.copy(alpha = .4f)
    )
}



